import { render } from "./TheCertificationsModal.vue?vue&type=template&id=0b2c44dc&scoped=true&ts=true"
import script from "./TheCertificationsModal.vue?vue&type=script&lang=ts"
export * from "./TheCertificationsModal.vue?vue&type=script&lang=ts"

import "./TheCertificationsModal.vue?vue&type=style&index=0&id=0b2c44dc&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2c44dc"]])

export default __exports__